// extracted by mini-css-extract-plugin
export var link = "_th-0";